import config from '../config';
import selectedEnvironment from '../env';
const API_BASE_URL = `${config[selectedEnvironment].API_URL}`;

const fetchAndExtract = async (url, options) => {
    const response = await fetch(url, options);
    if (!response.ok) {
        const error = new Error(`HTTP error! status: ${response.status}`);
        error.status = response.status;
        throw error;
    }
    return response.json();
};

const authHeaders = (auth) => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${auth}`
});

/** Full version rows (document settings dialog). */
const GetDesignVersions = async (caseId, auth) => fetchAndExtract(
    `${API_BASE_URL}/DocumentDesignVersions/GetByCaseId/${caseId}`,
    { method: 'GET', headers: authHeaders(auth) }
);

/** Lightweight { id, name, documentStyleVersion } list (document creation pickers). */
const GetDesignVersionOptions = async (caseId, auth) => fetchAndExtract(
    `${API_BASE_URL}/DocumentDesignVersions/GetOptions/${caseId}`,
    { method: 'GET', headers: authHeaders(auth) }
);

const CreateDesignVersion = async (dto, auth) => fetchAndExtract(
    `${API_BASE_URL}/DocumentDesignVersions/Create`,
    { method: 'POST', headers: authHeaders(auth), body: JSON.stringify(dto) }
);

const UpdateDesignVersion = async (dto, auth) => fetchAndExtract(
    `${API_BASE_URL}/DocumentDesignVersions/Update`,
    { method: 'POST', headers: authHeaders(auth), body: JSON.stringify(dto) }
);

const DeleteDesignVersion = async (caseId, id, auth) => fetchAndExtract(
    `${API_BASE_URL}/DocumentDesignVersions/Delete/${caseId}/${id}`,
    { method: 'DELETE', headers: authHeaders(auth) }
);

export {
    GetDesignVersions,
    GetDesignVersionOptions,
    CreateDesignVersion,
    UpdateDesignVersion,
    DeleteDesignVersion,
};
